import { RoleType } from "../types";
import { ServiceEndpoints } from "../constants";
import { axios } from "./apiConfig";

// Fetch all role
export const getRole = async () => {
  return axios
    .get(ServiceEndpoints.ROLES)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Create a new role
export const createRole = async (data: RoleType) => {
  return axios
    .post(ServiceEndpoints.ROLES, data)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Get a role by its ID
export const getRoleById = async (id: string) => {
  return axios
    .get(`${ServiceEndpoints.ROLES}/${id}`)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Update an existing role
export const updateRole = async (id: string, data: RoleType) => {
  const { ...roleData } = data;

  return axios
    .put(`${ServiceEndpoints.ROLES}${id}`, roleData)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Delete a role
export const deleteRole = async (id: string) => {
  return axios
    .delete(`${ServiceEndpoints.ROLES}${id}`)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};
